import {tableActionTypes as actions} from './actionTypes';
import {updateUserPreference} from './userActions';
import {Sorting} from 'helpers/constants';

export const changeSort = ({
  table,
  sortColumn,
  sortOrder,
  sortColumnPrefName = null,
  sortOrderPrefName = null,
  updateUserPref = false,
}) => async dispatch => {
  dispatch({
    type: actions.SORT_CHANGED,
    payload: {
      table,
      sortInfo: {
        sortColumn,
        sortOrder,
      },
    },
  });

  // update user preferences if prefs exist
  if (updateUserPref && sortColumnPrefName) {
    await dispatch(updateUserPreference(sortColumnPrefName, sortColumn, true));
  }
  if (updateUserPref && sortOrderPrefName) {
    dispatch(
      updateUserPreference(
        sortOrderPrefName,
        sortOrder === Sorting.desc ? 'desc' : 'asc',
        true,
      ),
    );
  }
};

export const changePageNumber = (table, pageNumber) => ({
  type: actions.PAGE_NUMBER_CHANGED,
  payload: {
    table,
    pageNumber,
  },
});

export const changePageSize = (
  pageSize,
  updateUserPref = false,
) => dispatch => {
  // optimistic update
  dispatch({
    type: actions.PAGE_SIZE_CHANGED,
    payload: {
      pageSize,
    },
  });

  if (updateUserPref) {
    dispatch(updateUserPreference('tlDashboardPageSize', pageSize, true));
  }
};

export const changeFilter = ({
  table,
  customViewEditable,
  customViewId,
  customViewName,
  filterPrefName,
  updateUserPref = false,
}) => dispatch => {
  dispatch({
    type: actions.FILTER_CHANGED,
    payload: {
      table,
      customViewEditable,
      customViewId,
      customViewName,
    },
  });

  if (updateUserPref) {
    dispatch(updateUserPreference(filterPrefName, customViewId, true));
  }
};



// WEBPACK FOOTER //
// ./src/actions/tableActions.js